import { render, staticRenderFns } from "./AnamnesisPage.vue?vue&type=template&id=d64e0746&scoped=true&"
import script from "./AnamnesisPage.vue?vue&type=script&lang=ts&"
export * from "./AnamnesisPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64e0746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
